import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

export type CPBenefitLineupModalLocs =
	| 'CPBenefitLineupModalNoticeChangesSaved'
	| 'CPBenefitLineupModalOptInHasLineup'
	| 'CPBenefitLineupModalButtonClose'
	| 'CPBenefitLineupModalButtonOptIn'
	| 'CPBenefitLineupModalOptInInstructions'
	| 'CPBenefitLineupModalNoEmailWarning'
	| 'CPBenefitLineupModalOptInSuccess'
	| 'CPBenefitLineupModalOptInFailure';

export const cpBenefitLineupModalLocs: LocDefs<CPBenefitLineupModalLocs> = {
	CPBenefitLineupModalNoticeChangesSaved: {
		defaultValue: 'Changes saved',
		description: 'Notice for changes saved',
		displayPath: `Benefits|Program|Notification Message|Changes Saved`,
		displayType: 'Notification',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit/Benefits.Program.NotificationMessage.ChangesSaved',
		portal: 'CP' as LocPortal,
	},
	CPBenefitLineupModalOptInHasLineup: {
		defaultValue:
			'<p>Your account has been created at Lineup, you should receive an email shortly.</p>',
		description: 'Content for when the user has already opted in to Lineup',
		displayPath: `Benefits|Program|Notification Message|Changes Saved`,
		displayType: 'Content',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Content.AlreadyOptIn',
		portal: 'CP' as LocPortal,
		htmlAllowed: true,
	},
	CPBenefitLineupModalButtonClose: {
		defaultValue: 'Close',
		description: 'Button to close the modal',
		displayPath: `Benefits|Program|Button|Close`,
		displayType: 'Button',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Button.Close',
		portal: 'CP' as LocPortal,
	},
	CPBenefitLineupModalButtonOptIn: {
		defaultValue: 'Opt-In',
		description: 'Button to opt in to Lineup',
		displayPath: `Benefits|Program|Button|OptIn`,
		displayType: 'Button',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Button.OptIn',
		portal: 'CP' as LocPortal,
	},
	CPBenefitLineupModalOptInInstructions: {
		defaultValue:
			'<p>By clicking below, an email will be sent to the following email address. Please verify that the email address is correct. If not, please update your demographics.</p>',
		description: 'Button to opt in to Lineup',
		displayPath: `Benefits|Program|Button|OptIn`,
		displayType: 'Button',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Button.OptIn',
		portal: 'CP' as LocPortal,
		htmlAllowed: true,
	},
	CPBenefitLineupModalNoEmailWarning: {
		defaultValue:
			'<p>You need a valid email address in order to create a Lineup account. Please update add an email address in the My Information page under Profile.	</p>',
		description: 'Warning for when the user does not have an email address',
		displayPath: `Benefits|Program|Content|No Email Warning`,
		displayType: 'Content',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Content.NoEmailWarning',
		portal: 'CP' as LocPortal,
		htmlAllowed: true,
	},
	CPBenefitLineupModalOptInSuccess: {
		defaultValue:
			'Your account has been created at Lineup, you should receive an email shortly.',
		description: 'Success message for when the user opts in to Lineup',
		displayPath: `Benefits|Program|Notification Message|OptIn Success`,
		displayType: 'Notification',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Notification.OptInSuccess',
		portal: 'CP' as LocPortal,
	},
	CPBenefitLineupModalOptInFailure: {
		defaultValue:
			'There was an error connecting to Lineup. If the problem persists, please contact customer support.',
		description: 'Error message for when the user opts in to Lineup',
		displayPath: `Benefits|Program|Notification Message|OptIn Failure`,
		displayType: 'Notification',
		feature: HubFeature.BenefitLineup,
		legacyName: 'Benefit.Lineup/Benefits.Program.Notification.OptInFailure',
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<CPBenefitLineupModalLocs>(cpBenefitLineupModalLocs);
